/* eslint-disable */
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import TimezoneError from 'components/ErrorScreens/TimezoneError';
import NotAssignedError from 'components/ErrorScreens/NotAssignedError';
import { whereAmI } from 'helpers/errorHelpers';

interface SessionInformation {
  login: string;
  userId: string;
  [key: string]: any;
}

const doRedirect = (error: Error & { xhr?: string }) => {
  if (error && (error.name === 'AuthApiError' && error.xhr && Object.keys(error.xhr).length === 0)) {
    return true;
  }
  return false;
};

const errorSender = (error: Error, moreInfo?: SessionInformation) => {
  if (window.newrelic) {
    const newRelic = window.newrelic;
    newRelic.noticeError(
      new Error('OktaReactError'),
      {
        type: 'OktaReactErrorComponent',
        env: whereAmI(),
        oktaError: error,
        userId: moreInfo?.userId,
        login: moreInfo?.login,
        didRedirect: doRedirect(error)
      }
    );
  }
  console.error('OktaReactError', {
    type: 'OktaReactErrorComponentConsole',
    env: whereAmI(),
    oktaError: error,
    userId: moreInfo?.userId,
    login: moreInfo?.login
  });
};

const OktaErrorHandler = ({ error, oktaAuth }: { error: Error; oktaAuth: any; }) => {
  const navigate = useNavigate()

  if (oktaAuth && oktaAuth.session) {
    oktaAuth.session.get().then((response: SessionInformation) => {
      errorSender(error, response);
    }).catch(() => {
      errorSender(error);
    });
  } else {
    errorSender(error);
  }

  useEffect(() => {
    if (error && doRedirect(error)) {
      navigate(window.location.hostname);
    }
  }, [error, history]);

  if (error.message === 'The JWT expired and is no longer valid' || error.message === 'The JWT was issued in the future') {
    return <TimezoneError />;
  } else if (error.message === 'User is not assigned to the client application.') {
    return <NotAssignedError />;
  }

  return (
    <div>
      <p>{`Error Name: ${error.name} Message: ${error.message}`}</p>
    </div>
  );
};

export default OktaErrorHandler;